"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitcoinRPC = void 0;
const bitcoin_rpc_1 = __importDefault(require("./bitcoin-rpc"));
exports.BitcoinRPC = bitcoin_rpc_1.default;
//# sourceMappingURL=index.js.map